import { eventBus } from 'general/js/events';
import throttle from 'lodash/throttle';

export const initScrollEmitter = () => {
    const handler = throttle(() => eventBus.emit('pageScrolled'), 50);
    window.addEventListener('scroll', () => handler(), { passive: true });
};
